// Shared role styling for Navbar / role badges across the app.

export const ROLE_COLORS = {
  super_admin: 'bg-red-100 text-red-700',
  admin: 'bg-purple-100 text-purple-700',
  manager: 'bg-blue-100 text-blue-700',
  member: 'bg-green-100 text-green-700',
  viewer: 'bg-gray-100 text-gray-600',
};

export const ROLE_LABELS = {
  super_admin: 'Super Admin',
  admin: 'Admin',
  manager: 'Manager',
  member: 'Member',
  viewer: 'Viewer',
};

export const DEMO_ROLE_EMAILS = [
  'demo@allaboutclaims.com',
  'viewer@demo.com',
  'member@demo.com',
  'manager@demo.com',
];
